import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageShell } from "../components/layout/PageShell";
import { PRICING } from "../data/siteContent";

export default function PricingPage() {
  const navigate = useNavigate();
  return (
    <PageShell>
      <section data-testid="pricing-page" className="relative pt-36 md:pt-44 pb-16 overflow-hidden grain">
        <div className="aurora-weave" />
        <div className="line-weave" />
        <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 text-center">
          <p className="text-sm tracking-[0.24em] uppercase text-[#E7CC86]/80 mb-4">{PRICING.eyebrow}</p>
          <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-cream mb-5">
            Ways to <span className="text-gold">begin.</span>
          </h1>
          <p className="text-lg text-cream/70 max-w-2xl mx-auto">{PRICING.sub}</p>
        </div>
      </section>

      <section className="relative py-10 md:py-24 bg-[#0B1020] overflow-hidden">
        <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8">
          <motion.div data-testid="pricing-table" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
            className="glass rounded-3xl overflow-hidden">
            {/* The table is the page's main section but carries no visible heading,
                which left a h1 -> h3 gap for screen readers. */}
            <h2 className="sr-only">Investment by offering</h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-[#101728]">
                    <th className="px-6 py-4 font-display font-semibold text-sm md:text-base tracking-wide text-cream">Offering</th>
                    <th className="px-6 py-4 font-display font-semibold text-sm md:text-base tracking-wide text-cream">Investment</th>
                  </tr>
                </thead>
                <tbody>
                  {PRICING.rows.map((r, i) => (
                    <tr key={r.offering} className={i % 2 === 1 ? "bg-white/[0.03]" : ""}>
                      <td className="px-6 py-4 border-t border-[#C9A24B]/10 text-cream/75 text-sm md:text-base">{r.offering}</td>
                      <td className="px-6 py-4 border-t border-[#C9A24B]/10 text-[#E7CC86] font-semibold text-sm md:text-base whitespace-nowrap">{r.price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </motion.div>

          {/* Bespoke offers no longer carry a public figure — the next step is a conversation. */}
          <motion.div
            data-testid="pricing-inquiry"
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="mt-10 text-center max-w-2xl mx-auto"
          >
            <p className="text-cream/70 text-base md:text-lg leading-relaxed mb-7">{PRICING.note}</p>
            <button
              data-testid="pricing-connect-cta"
              onClick={() => navigate("/connect")}
              className="btn-gold inline-flex items-center gap-2 px-8 py-3.5 rounded-full text-base font-semibold tracking-wide"
            >
              {PRICING.cta} <ArrowRight size={18} />
            </button>
          </motion.div>
        </div>
      </section>
    </PageShell>
  );
}
